module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.color,
    attrs: {
      "id": "table-header"
    }
  }, [_c('span', {
    attrs: {
      "id": "title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-7190a943!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/TableHeader.vue
// module id = 1050
// module chunks = 40